import ResponseMenuUser from "./ResponseMenuUser";

export default ResponseMenuUser;
